import React from "react";
import SEO from "../seo/SEO";
import { businessSchema, websiteSchema, faqSchema } from "../seo/schema";
import Hero from "../Components/sections/Hero";
import TrustStatement from "../Components/sections/TrustStatement";
import FeaturedProject from "../Components/sections/FeaturedProject";
import ServiceIndex from "../Components/sections/ServiceIndex";
import BeforeAfter from "../Components/sections/BeforeAfter";
import Process from "../Components/sections/Process";
import ProjectCollection from "../Components/sections/ProjectCollection";
import WhyUs from "../Components/sections/WhyUs";
import ServiceAreasSection from "../Components/sections/ServiceAreasSection";
import Testimonials from "../Components/sections/Testimonials";
import FAQ from "../Components/sections/FAQ";
import CTABand from "../Components/sections/CTABand";
import useProjects from "../hooks/useProjects";
import { GENERAL_FAQS } from "../data/faqs";

/**
 * Homepage.
 *
 * The sequence is an argument, in order: what we do → why trust us → proof →
 * what we offer → proof of transformation → how it runs → more proof → what
 * separates us → where we work → what we commit to → objections → ask.
 *
 * Ink and paper alternate deliberately down the page (ink hero, paper, ink,
 * paper, stone, stone, paper, ink, paper, stone, paper, ink) so no two dark
 * bands sit adjacent and the eye gets a rhythm rather than a wall.
 *
 * The homepage carries the site-wide Organization and WebSite structured data;
 * every other page references the business node by @id instead of repeating it.
 */
const HomePage = () => {
  const projects = useProjects();

  return (
    <>
      <SEO
        title="Five Lights Reno | Renovation Contractor in Pickering & Durham Region"
        description="Renovation contractor based in Pickering, Ontario. Kitchens, bathrooms, legal basement conversions, flooring, tile and painting across Pickering, Ajax, Whitby and Durham Region."
        path="/"
        jsonLd={[businessSchema(), websiteSchema(), faqSchema(GENERAL_FAQS)]}
      />

      <Hero />
      <TrustStatement />
      <FeaturedProject />
      <ServiceIndex
        intro="Kitchens and bathrooms through to legal basements, flooring, tile, drywall and paint. Most of it self-performed, which is why the finished details line up."
      />
      <BeforeAfter />
      <Process />
      <ProjectCollection
        projects={projects}
        limit={4}
        eyebrow="Recent work"
        intro="Four of our projects. Every photograph is from one of our own job sites — some finished, some mid-build, and the captions say which."
      />
      <WhyUs />
      <ServiceAreasSection />
      <Testimonials />
      <FAQ faqs={GENERAL_FAQS} idPrefix="home-faq" />
      <CTABand />
    </>
  );
};

export default HomePage;
